import { useState } from 'react'
import classes from './Item.module.css'
import ReinstateiItem from './ReinstateiItem'
import { formatDateLocal } from '../../../../lib/script'
import { deleteEntityPermission } from '../../../../lib/permissions'
import { useSelector } from 'react-redux'

const Item = ({children, data, mainItem, type, folder, lastChild, delete_spec}) => {

    const [showAllMessage, setShowAllMesssage] = useState(false)

    const user = useSelector(state => state.user.user)

    function mouseEnterHandler() {
        setShowAllMesssage(true)        
    }
    function mouseLeaveHandler() {
        setShowAllMesssage(false)
    }

    return <div className={`details-tab-item ${classes.item} ${mainItem ? classes.main_item : ''} ${lastChild ? 'item_last_child_global' : ''} ${!data.active ? classes.item_removed : ''}`}>
        {!data.active && deleteEntityPermission(user?.permissions, delete_spec ? delete_spec : folder) && <ReinstateiItem data={data} type={type} folder={folder}/>}

        {/* {!data.active && data.drop_reason && <div className={`${classes.drop_reason_container} ${showAllMessage ? classes.drop_reason_container_expanded : ''}`} onMouseEnter={mouseEnterHandler} onMouseLeave={mouseLeaveHandler}>
            <div className={classes.reason_label}>Archived Reason:</div>
            <div>{data.drop_reason} </div>   
        </div>} */}
        <div className={`${!data.active ? classes.item_inactive : ''}`}>
            {children}

            
        </div>
        {(!data.active && data.remove_reason && data.remove_date) && <div className={classes.item_footer}>
            <h3 className={classes.drop_reason_header}>Removed on {formatDateLocal(data.remove_date)} </h3>
            <p className={classes.drop_reason_body}>{data.remove_reason}</p>           
            {/* <div className={classes.flex_4}>
                <DefaultUpdater type={'input'} value={data.drop_reason} label={'Drop Reason'} identifier={{type: 'case_attorney', field: 'drop_reason', type_id: data.id, folder: 'attorneys'}} />
            </div>
            <div className={classes.flex_1}>
                <DefaultUpdater type={'date'} value={data.drop_date} label={'Drop Date'} identifier={{type: 'case_attorney', field: 'drop_date', type_id: data.id, folder: 'attorneys'}}/>
            </div> */}
        </div>}
    </div>
}

export default Item